/**
 * Questionnaire v2 — Étapes 2, 3 et 4
 * Univers floral, invités, bouquets
 */
(function () {
  'use strict';

  let initialized = false;
  let universGallery = null;
  const selectedBouquets = [];

  function getUncroppedImageUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;
    let url = rawUrl.trim().replace(/&amp;/g, '&');
    url = url.replace(/_\d+x\d+_crop_center(?=\.)/i, '');
    url = url.replace(/_crop_center(?=\.)/i, '');
    url = url.replace(/_\d+x\d+(?=\.)/i, '');
    url = url.replace(/_\d+x(?=\.)/i, '');
    url = url.replace(/_x\d+(?=\.)/i, '');
    url = url.replace(/([?&])width=\d+(&|$)/i, '$1');
    url = url.replace(/([?&])height=\d+(&|$)/i, '$1');
    url = url.replace(/([?&])crop=[^&]*(&|$)/i, '$1');
    url = url.replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/, '');
    return url;
  }

  function setValidationButtonState(button, disabled) {
    if (button) button.disabled = disabled;
  }

  function getWeddingDateInput() {
    return document.getElementById('qv2-wedding-date');
  }

  function setupNumericInputValidation(input, errorElement, maxLength, onValidationChange) {
    if (!input) return;

    const errorMessage = 'Le nombre ne peut pas dépasser ' + maxLength + ' chiffres.';

    function showError() {
      if (errorElement) {
        errorElement.style.display = 'block';
        errorElement.textContent = errorMessage;
      }
    }

    function hideError() {
      if (errorElement) errorElement.style.display = 'none';
    }

    function processValue(value) {
      const numbers = value.replace(/[^0-9]/g, '');
      if (numbers.length > maxLength) {
        showError();
        return numbers.slice(0, maxLength);
      }
      hideError();
      return numbers;
    }

    if (input.dataset.qv2NumericBound) return;
    input.dataset.qv2NumericBound = '1';

    input.addEventListener('input', function () {
      this.value = processValue(this.value);
      if (onValidationChange) onValidationChange();
    });
    input.addEventListener('blur', function () {
      this.value = processValue(this.value);
      if (onValidationChange) onValidationChange();
    });
    input.addEventListener('paste', function (e) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData).getData('text');
      this.value = processValue(pasted);
      if (onValidationChange) onValidationChange();
    });
  }

  function setupNoOptionButton(noButton, itemsSelector, onToggle, onValidation) {
    if (!noButton || noButton.dataset.qv2NoBound) return;
    noButton.dataset.qv2NoBound = '1';

    noButton.addEventListener('click', function () {
      this.classList.toggle('selected');
      if (this.classList.contains('selected')) {
        document.querySelectorAll(itemsSelector).forEach(function (item) {
          item.classList.remove('selected');
        });
      }
      if (onToggle) onToggle(this.classList.contains('selected'));
      if (onValidation) onValidation();
    });
  }

  function setupMultipleItemSelection(itemSelector, idAttribute, selectedArray, noButton, onValidation) {
    document.querySelectorAll(itemSelector).forEach(function (item) {
      if (item.dataset.qv2SelectBound) return;
      item.dataset.qv2SelectBound = '1';

      item.addEventListener('click', function () {
        if (noButton && noButton.classList.contains('selected')) {
          noButton.classList.remove('selected');
        }
        this.classList.toggle('selected');
        const itemId = this.getAttribute(idAttribute);
        if (this.classList.contains('selected')) {
          if (!selectedArray.includes(itemId)) selectedArray.push(itemId);
        } else {
          const index = selectedArray.indexOf(itemId);
          if (index > -1) selectedArray.splice(index, 1);
        }
        if (onValidation) onValidation();
      });
    });
  }

  class ImageGalleryModal {
    constructor(config) {
      this.modal = document.getElementById(config.modalId);
      this.modalImage = document.getElementById(config.imageId);
      this.modalCounter = document.getElementById(config.counterId);
      this.modalTitle = document.getElementById(config.titleId);
      this.modalPrev = document.getElementById(config.prevId);
      this.modalNext = document.getElementById(config.nextId);
      this.modalClose = document.getElementById(config.closeId);
      this.modalOverlay = this.modal ? this.modal.querySelector('.modal-overlay') : null;
      this.modalSelectBtn = document.getElementById(config.selectBtnId);
      this.onSelect = config.onSelect || null;
      this.images = [];
      this.currentIndex = 0;
      this.currentTitle = '';
      this.currentElement = null;
      this.minSwipeDistance = 50;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
      this.init();
    }

    init() {
      if (this.modalPrev) this.modalPrev.addEventListener('click', () => this.goToPrevious());
      if (this.modalNext) this.modalNext.addEventListener('click', () => this.goToNext());
      if (this.modalClose) this.modalClose.addEventListener('click', () => this.close());
      if (this.modalOverlay) this.modalOverlay.addEventListener('click', () => this.close());
      if (this.modalSelectBtn) this.modalSelectBtn.addEventListener('click', () => this.handleSelect());

      if (this.modalImage) {
        this.modalImage.addEventListener('dblclick', () => this.handleSelect());
        this.modalImage.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });
        this.modalImage.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.touchEndY = e.changedTouches[0].screenY;
          const deltaX = this.touchEndX - this.touchStartX;
          const deltaY = this.touchEndY - this.touchStartY;
          if (Math.abs(deltaX) > this.minSwipeDistance && Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX > 0) this.goToPrevious();
            else this.goToNext();
          }
        }, { passive: true });
      }

      if (!document.body.dataset.qv2GalleryEsc) {
        document.body.dataset.qv2GalleryEsc = '1';
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal && this.modal.classList.contains('active')) {
            this.close();
          }
        });
      }
    }

    open(item, imagesData, title, imageCount) {
      if (!imagesData || imagesData === '' || imageCount === 0) return false;
      this.images = imagesData.split('|||');
      this.currentIndex = 0;
      this.currentTitle = title;
      this.currentElement = item;
      this.loadImage(this.images[0], 1, this.images.length);
      if (this.modal) {
        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
      return true;
    }

    loadImage(imageUrl, index, total) {
      if (this.modalImage) this.modalImage.src = getUncroppedImageUrl(imageUrl);
      if (this.modalCounter) this.modalCounter.textContent = index + ' / ' + total;
      if (this.modalTitle) this.modalTitle.textContent = this.currentTitle;
      if (this.modalPrev) this.modalPrev.disabled = index === 1;
      if (this.modalNext) this.modalNext.disabled = index === total;
    }

    goToPrevious() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.loadImage(this.images[this.currentIndex], this.currentIndex + 1, this.images.length);
      }
    }

    goToNext() {
      if (this.currentIndex < this.images.length - 1) {
        this.currentIndex++;
        this.loadImage(this.images[this.currentIndex], this.currentIndex + 1, this.images.length);
      }
    }

    close() {
      if (this.modal) {
        this.modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    handleSelect() {
      if (this.currentElement && this.onSelect) {
        this.onSelect(this.currentElement);
        this.close();
      }
    }
  }

  function syncValidateStep2Button() {
    const validateBtn = document.getElementById('validate-step-2');
    if (validateBtn) {
      validateBtn.disabled = !document.querySelector('.univers-item.selected');
    }
  }

  function selectUnivers(item) {
    if (!item || item.classList.contains('unavailable')) return;
    document.querySelectorAll('.univers-item').forEach(function (i) {
      if (i !== item) i.classList.remove('selected');
    });
    item.classList.add('selected');
    syncValidateStep2Button();
  }

  function openUniversGallery(universItem, options) {
    options = options || {};
    if (!universGallery) {
      if (!options.zoomOnly) selectUnivers(universItem);
      return false;
    }
    const imagesData = universItem.getAttribute('data-univers-images');
    const universTitle = universItem.getAttribute('data-univers-title');
    const imageCount = parseInt(universItem.getAttribute('data-image-count'), 10) || 0;
    if (universGallery.open(universItem, imagesData, universTitle, imageCount)) {
      return true;
    }
    if (!options.zoomOnly) selectUnivers(universItem);
    return false;
  }

  function openUniversZoom(universItem, zoomBtn) {
    if (window.QV2 && typeof window.QV2.ensureSharedUiInBody === 'function') {
      window.QV2.ensureSharedUiInBody();
    }
    if (openUniversGallery(universItem, { zoomOnly: true })) return;
    const src = (window.QV2 && window.QV2.resolveZoomImageSrc)
      ? window.QV2.resolveZoomImageSrc(zoomBtn)
      : (zoomBtn.getAttribute('data-lightbox-src') || '');
    if (src && window.QV2 && typeof window.QV2.openImageLightbox === 'function') {
      window.QV2.openImageLightbox(src);
    }
  }

  function updateUniversSeasonalAvailability() {
    const weddingDateInput = getWeddingDateInput();
    if (!weddingDateInput || !weddingDateInput.value) {
      document.querySelectorAll('.univers-item').forEach(function (item) {
        item.classList.remove('unavailable');
      });
      return;
    }

    const dateParts = weddingDateInput.value.split('-');
    if (dateParts.length < 2) return;
    const month = parseInt(dateParts[1], 10);
    if (isNaN(month) || month < 1 || month > 12) return;

    document.querySelectorAll('.univers-item').forEach(function (item) {
      const universName = (item.getAttribute('data-univers-name') || '').toLowerCase().trim();
      const universTitle = (item.getAttribute('data-univers-title') || '').toLowerCase().trim();
      const fullName = universName || universTitle;
      item.classList.remove('unavailable');

      if (fullName.includes('pivoine') && (fullName.includes('élégante') || fullName.includes('elegante') || fullName.includes('romantique'))) {
        if (month < 4 || month > 6) item.classList.add('unavailable');
      }
      if (fullName.includes('tulipe') && (fullName.includes('sophistiquée') || fullName.includes('sophistiquee'))) {
        if (month > 4) item.classList.add('unavailable');
      }
      if (fullName.includes('romance pure') ||
          (fullName.includes('douceur') && fullName.includes('agrume')) ||
          (fullName.includes('rayon') && fullName.includes('soleil')) ||
          (fullName.includes('renoncule') && (fullName.includes('blanche') || fullName.includes('jaune') || fullName.includes('pêche') || fullName.includes('peche')))) {
        if (month > 3) item.classList.add('unavailable');
      }
    });
  }

  function getStepUniversCount(stepEl) {
    if (!stepEl) return 0;
    return stepEl.querySelectorAll('.questionnaire-univers-grid .univers-item').length;
  }

  function syncStep2UniversVisibility() {
    const step2 = document.querySelector('.questionnaire-step[data-step="2"]');
    if (!step2) return;

    const grid = step2.querySelector('.questionnaire-univers-grid');
    if (!grid) return;

    const visibleCount = parseInt(grid.getAttribute('data-univers-visible-count'), 10) || 4;
    const items = grid.querySelectorAll('.univers-item');
    const showAll = grid.classList.contains('show-all');

    items.forEach(function (item, index) {
      const shouldHide = !showAll && index >= visibleCount;
      item.classList.toggle('univers-item-hidden', shouldHide);
      if (shouldHide) {
        item.style.display = 'none';
      } else {
        item.style.removeProperty('display');
      }
    });

    const seeMoreWrap = step2.querySelector('.questionnaire-see-more');
    if (seeMoreWrap) {
      seeMoreWrap.style.display = items.length > visibleCount ? '' : 'none';
    }
  }

  function initStep2SeeMore() {
    if (document.body.dataset.qv2UniversSeeMore) return;
    document.body.dataset.qv2UniversSeeMore = '1';
    document.addEventListener('click', function (e) {
      const link = e.target.closest('.questionnaire-step[data-step="2"] .see-more-link');
      if (!link) return;
      e.preventDefault();
      const step2 = link.closest('.questionnaire-step[data-step="2"]');
      if (!step2) return;
      const universGrid = step2.querySelector('.questionnaire-univers-grid');
      if (!universGrid) return;
      const isExpanded = universGrid.classList.toggle('show-all');
      link.textContent = isExpanded ? 'VOIR MOINS' : 'VOIR PLUS';
      syncStep2UniversVisibility();
    });
  }

  function resetStep2UniversGrid() {
    const step2 = document.querySelector('.questionnaire-step[data-step="2"]');
    if (!step2) return;
    const universGrid = step2.querySelector('.questionnaire-univers-grid');
    const seeMoreLink = step2.querySelector('.see-more-link');
    if (universGrid) universGrid.classList.remove('show-all');
    if (seeMoreLink) seeMoreLink.textContent = 'VOIR PLUS';
    syncStep2UniversVisibility();
  }

  async function ensureStep2UniversCards() {
    const hostStep = document.querySelector('#qv2-steps-host .questionnaire-step[data-step="2"]') ||
      document.querySelector('.questionnaire-step[data-step="2"]');
    if (hostStep && getStepUniversCount(hostStep) > 0) {
      syncStep2UniversVisibility();
      return;
    }

    if (window.QV2 && typeof window.QV2.adoptInlineSteps === 'function') {
      window.QV2.adoptInlineSteps('qv2_step_02_04');
    }

    const afterAdopt = document.querySelector('#qv2-steps-host .questionnaire-step[data-step="2"]') ||
      document.querySelector('.questionnaire-step[data-step="2"]');
    if (afterAdopt && getStepUniversCount(afterAdopt) > 0) {
      syncStep2UniversVisibility();
      return;
    }

    if (window.QV2 && typeof window.QV2.reloadStepSection === 'function') {
      await window.QV2.reloadStepSection('qv2_step_02_04', 2);
      syncStep2UniversVisibility();
    }
  }

  function hasSteps0204Content() {
    return !!(
      document.querySelector('[data-qv2-section="02-04"]') ||
      document.querySelector('.questionnaire-step[data-step="2"]') ||
      document.querySelector('.questionnaire-step[data-step="3"]') ||
      document.querySelector('.questionnaire-step[data-step="4"]')
    );
  }

  function initStep2() {
    if (window.QV2 && typeof window.QV2.ensureSharedUiInBody === 'function') {
      window.QV2.ensureSharedUiInBody();
    }

    initStep2SeeMore();

    if (!universGallery && document.getElementById('univers-gallery-modal')) {
      universGallery = new ImageGalleryModal({
        modalId: 'univers-gallery-modal',
        imageId: 'modal-image',
        counterId: 'modal-counter',
        titleId: 'modal-title',
        prevId: 'modal-prev',
        nextId: 'modal-next',
        closeId: 'modal-close',
        selectBtnId: 'modal-select-btn',
        onSelect: selectUnivers
      });
    }

    if (!document.body.dataset.qv2UniversClick) {
      document.body.dataset.qv2UniversClick = '1';
      document.addEventListener('click', function (e) {
        const step2 = document.querySelector('.questionnaire-step[data-step="2"]');
        if (!step2 || !step2.contains(e.target)) return;

        const zoomBtn = e.target.closest('.univers-item .image-zoom-btn');
        if (zoomBtn) {
          e.preventDefault();
          e.stopPropagation();
          const universItem = zoomBtn.closest('.univers-item');
          if (universItem && !universItem.classList.contains('unavailable')) {
            openUniversZoom(universItem, zoomBtn);
          }
          return;
        }

        const universItem = e.target.closest('.univers-item');
        if (!universItem) return;
        if (universItem.classList.contains('unavailable')) return;

        if (universItem.classList.contains('selected')) {
          universItem.classList.remove('selected');
          syncValidateStep2Button();
          return;
        }

        selectUnivers(universItem);
        const imagesData = universItem.getAttribute('data-univers-images');
        if (imagesData && imagesData.trim() !== '') {
          openUniversGallery(universItem);
        }
      }, true);
    }

    const weddingDateInput = getWeddingDateInput();
    if (weddingDateInput && !weddingDateInput.dataset.qv2SeasonBound) {
      weddingDateInput.dataset.qv2SeasonBound = '1';
      weddingDateInput.addEventListener('change', updateUniversSeasonalAvailability);
      weddingDateInput.addEventListener('input', updateUniversSeasonalAvailability);
    }

    updateUniversSeasonalAvailability();
    syncValidateStep2Button();
    syncStep2UniversVisibility();
  }

  function initStep3() {
    const invitesInput = document.getElementById('nombre-invites');
    const invitesError = document.getElementById('invites-error');
    const validateStep3 = document.getElementById('validate-step-3');
    if (!invitesInput) return;

    function validateInvitesInput() {
      const value = invitesInput.value.trim();
      const isValid = value.length > 0 && value.length <= 3 && /^[0-9]+$/.test(value);
      setValidationButtonState(validateStep3, !isValid);
    }

    setupNumericInputValidation(invitesInput, invitesError, 3, validateInvitesInput);
    validateInvitesInput();
  }

  function initStep4() {
    const noBouquetBtn = document.getElementById('no-bouquet-btn');
    const validateStep4 = document.getElementById('validate-step-4');
    if (!document.querySelector('.bouquet-item') && !noBouquetBtn) return;

    function updateStep4Validation() {
      setValidationButtonState(
        validateStep4,
        selectedBouquets.length === 0 && (!noBouquetBtn || !noBouquetBtn.classList.contains('selected'))
      );
    }

    setupMultipleItemSelection('.bouquet-item', 'data-bouquet-id', selectedBouquets, noBouquetBtn, updateStep4Validation);
    setupNoOptionButton(
      noBouquetBtn,
      '.bouquet-item',
      function (isActive) {
        if (isActive) selectedBouquets.length = 0;
      },
      function () {
        setValidationButtonState(validateStep4, false);
      }
    );
    updateStep4Validation();
  }

  function initSteps0204() {
    if (!hasSteps0204Content()) return;
    initStep2();
    initStep3();
    initStep4();
    initialized = true;
  }

  function onStepShown(stepNumber) {
    if (stepNumber >= 2 && stepNumber <= 4) {
      initSteps0204();
      if (stepNumber === 2) {
        ensureStep2UniversCards().then(function () {
          resetStep2UniversGrid();
          updateUniversSeasonalAvailability();
          initStep2();
        });
      }
    }
  }

  window.QV2_STEPS_02_04 = {
    init: initSteps0204,
    onStepShown: onStepShown,
    syncStep2UniversVisibility: syncStep2UniversVisibility,
    updateUniversSeasonalAvailability: updateUniversSeasonalAvailability,
    getState: function () {
      return { selectedBouquets: selectedBouquets.slice() };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSteps0204);
  } else {
    initSteps0204();
  }
})();
